import { render, staticRenderFns } from "./CreateCourseDialog.vue?vue&type=template&id=1676eb16&"
import script from "./CreateCourseDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateCourseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports